const defaultOptions = {
  duration: 400,
  delay: 0
};
const slideUp = (target, options = defaultOptions, callback) => {
  let { display } = window.getComputedStyle(target);
  if (display === "none") display = "block";
  target.style.display = display;
  target.style.transitionProperty = "height";
  target.style.transitionDuration = `${options.duration}ms`;
  target.style.transitionTimingFunction = options.easing ? options.easing : "ease";
  target.style.height = `${target.offsetHeight}px`;
  setTimeout(() => {
    console.log(target.offsetHeight);
    target.style.overflow = "hidden";
    target.style.height = "0px";
    setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("opacity");
      target.style.removeProperty("overflow");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
      target.style.display = "none";
      if (callback) {
        callback();
      }
    }, options.duration);
  }, 10);
};
const slideDown = (target, options = defaultOptions, callback) => {
  const transition = () => {
    target.style.removeProperty("display");
    let { display } = window.getComputedStyle(target);
    if (display === "none") display = "block";
    target.style.display = display;
    const height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = "0px";
    target.offsetHeight;
    target.style.transitionProperty = "height";
    target.style.transitionDuration = `${options.duration}ms`;
    target.style.transitionTimingFunction = options.easing ? options.easing : "ease";
    target.style.height = `${height}px`;
    setTimeout(() => {
      target.style.removeProperty("height");
      target.style.removeProperty("height");
      target.style.removeProperty("overflow");
      target.style.removeProperty("opacity");
      target.style.removeProperty("transition-duration");
      target.style.removeProperty("transition-property");
      if (callback) {
        callback();
      }
    }, options.duration);
  };
  if (options.delay) {
    setTimeout(() => {
      transition();
    }, options.delay);
  } else {
    transition();
  }
};
export {
  slideDown as a,
  slideUp as s
};
